import Vue from 'vue';
import VueGtag from 'vue-gtag';
import http from '@/http';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';

// install the analytics plugin
Vue.use(VueGtag, {
  config: {
    id: 'G-Z4CRLKS46H',
    params: {
      anonymize_ip: true,
    },
  },
}, router);

Vue.prototype.$http = http;

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
